import { render, staticRenderFns } from "./BlogPostTags.vue?vue&type=template&id=74515da4"
import script from "./BlogPostTags.vue?vue&type=script&lang=ts"
export * from "./BlogPostTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports